export default defineNuxtPlugin(() => {
    // Initialize Google Analytics
    if (process.client) {
        const gaId = process.env.GOOGLE_ANALYTICS_ID || 'G-XXXXXXXXXX';

        useScript(`https://www.googletagmanager.com/gtag/js?id=${gaId}`);

        window.dataLayer = window.dataLayer || [];
        function gtag(...args: any[]) {
            window.dataLayer.push(args);
        }
        window.gtag = gtag;

        window.gtag('js', new Date().toISOString());
        window.gtag('config', gaId, {
            page_title: document.title,
            page_location: window.location.href
        });
    }
});

// Type declarations
declare global {
    interface Window {
        dataLayer: any[];
    }
}
